import { createContext, useContext } from 'react';

const ActionsContext = createContext(null);

export const useActions = () => {
  const ctx = useContext(ActionsContext);
  if (!ctx) throw new Error('useActions must be used inside AppProvider');
  return ctx;
};

export default ActionsContext;
